import React from 'react';
import { useFormikContext } from 'formik';
import { useStore } from 'components/Store';
import FormSection from 'components/FormSection';
import SectionWrapper from 'components/SectionWrapper';
import TagsSection from 'screens/Applications&WorkOrders/StepsLayout/Components/DetailsStep/components/TagsSection';
import PlanInfoSection from './components/PlanInfoSection';
import FixedCostSection from './components/FixedCostSection';
import ProjectedRevenueSection from './components/ProjectedRevenueSection';
import NotesSection from './components/NotesSection';
import {
  resolveFinancialAccess,
  isFinancialFieldDisabled
} from './helpers/financialAccess';
import { PlanWizardFormValues } from '../../types';
import './style.css';

/**
 * Details step of the Plan creation wizard — a composition root only.
 */
const DetailsStep: React.FC = () => {
  const {
    state: { loggedInUserOrgPermission }
  } = useStore();
  const { values } = useFormikContext<PlanWizardFormValues>();

  const memberRole = loggedInUserOrgPermission?.role;
  const memberFinancialAccess = resolveFinancialAccess(
    loggedInUserOrgPermission
  );
  const financialFieldsDisabled = isFinancialFieldDisabled(
    memberRole,
    memberFinancialAccess
  );

  const area = values.area || 1;

  return (
    <div
      className="flex flex-col w-full pb-4 plan-details-step"
      data-testid="plan-details-step"
    >
      <SectionWrapper isFirst>
        <FormSection title="PLAN INFO" autoHeight hasMarginBottom>
          <PlanInfoSection />
        </FormSection>
      </SectionWrapper>

      <SectionWrapper>
        <FormSection title="FIXED COST" autoHeight hasMarginBottom>
          <FixedCostSection
            area={area}
            financialFieldsDisabled={financialFieldsDisabled}
          />
        </FormSection>
      </SectionWrapper>

      <SectionWrapper>
        <FormSection title="PROJECTED REVENUE" autoHeight hasMarginBottom>
          <ProjectedRevenueSection
            area={area}
            financialFieldsDisabled={financialFieldsDisabled}
          />
        </FormSection>
      </SectionWrapper>

      <SectionWrapper>
        <FormSection title="TAGS" isOptional autoHeight hasMarginBottom>
          <TagsSection />
        </FormSection>
      </SectionWrapper>

      <SectionWrapper>
        <FormSection
          title="NOTES"
          isOptional
          bodyHeight={248}
          hasMarginBottom={false}
        >
          <NotesSection />
        </FormSection>
      </SectionWrapper>
    </div>
  );
};

export default DetailsStep;
